/*
 * Module for the Prenote Processing job criteria page
 */
rs.module("content/jobs/criteria/prenoteprocessingcontract",

    [/* Dependencies */],

    function () {

        // Initialize the page
        function initialize(jsSelectors, codeValues) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var payrollTypeSelect = form.js(jsSelectors.payrollTypeSelect);
            var accountStatusRadioContainer = form.js(jsSelectors.accountStatusRadioContainer);
            var prenoteOption = form.js(jsSelectors.prenoteOption);

            // Setup event listener(s)
            payrollTypeSelect.on("change", () => updateChildControls());

            // Updates controls which are dependent on the selected payroll type.
            function updateChildControls() {

                var payrollType = payrollTypeSelect.val();

                // enabled if periodic.
                if (payrollType == codeValues.periodic) {

                    accountStatusRadioContainer.find('input').setDisabled(false);

                }
                else {

                    // Clear radio buttons
                    accountStatusRadioContainer.find('input').setChecked(false);
                    accountStatusRadioContainer.find('input').setDisabled(true);

                    // set default selected option.
                    prenoteOption.setChecked(true);
                }
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);